export const CUSTOMER_ID_COOKIE_NAME = 'customerId';
export const YM_UID_COOKIE_NAME = '_ym_uid';
